import { useDisplayTime } from "./useDisplayTime"

export function useReadableTime(value: string | number): string {
  const displayTime = useDisplayTime()
  return displayTime(value)
}
